import clienteAxios from "../config/axios";

export async function deleteAndGetPagosByNroCtaFromSoftland (nroCta, companyName) {
    return clienteAxios.get(`/deleteAndGet/pagosByNroCtaFromSoftland/nroCta/${nroCta}/companyName/${companyName}`);
}

export async function getPagosByNroCta (nroCta, companyName) {
    return clienteAxios.get(`/pagos/nroCta/${nroCta}/companyName/${companyName}`);
}

export async function getPagosNotAnnulledByNroCta (nroCta, companyName) {
    return clienteAxios.get(`/pagosNotAnnulled/nroCta/${nroCta}/companyName/${companyName}`);
}

export async function createPDFOp(codFor, nroFor, companyName) {
  return clienteAxios.post("/pago/informe", { codFor, nroFor, companyName });
}